// HomePage.js
import React, { useState, useEffect } from 'react';
import ProductSearch from '../ProductSearch';
import MainContainer from '../MainContainer.css';
import MultiStepForm from './components/MultiStepForm';
import Grid from '@mui/material/Grid';

const HomePage = ({ onSelect, onRemoveFromSelectedProducts }) => {
  const productKey = (product) => product?.airtableRecordId || product?.thumbnailUrl;

  const [selectedProducts, setSelectedProducts] = useState([]);

  // Load selected products from local storage on component mount
  useEffect(() => {
    const storedProducts = JSON.parse(localStorage.getItem('selectedProducts')) || [];
    setSelectedProducts(storedProducts);
  }, []); // Empty dependency array ensures it runs only on mount

  const handleSelect = (product) => {
    // console.log(product);
    // setSelectedProducts((prevSelectedProducts) => [...prevSelectedProducts, product]);
    // Retrieve existing products from localStorage
    const storedProducts = JSON.parse(localStorage.getItem('selectedProducts')) || [];

    // Use a Set for unique products
    const updatedProducts = [...storedProducts.filter((stored) => productKey(stored) !== productKey(product)), product];

    // Save the updated products to localStorage
    localStorage.setItem('selectedProducts', JSON.stringify(updatedProducts));

    // Update state with the unique products
    setSelectedProducts(updatedProducts);
  }

  const handleRemoveFromSelectedProducts = (product) => {
      console.log("REMOVING PRODUCT: ", product);
      // CHANGE TO ID when added to DB
      const updatedProducts = selectedProducts.filter((p) => productKey(p) !== productKey(product));

      // Save the updated products to localStorage
      localStorage.setItem('selectedProducts', JSON.stringify(updatedProducts));

      localStorage.removeItem(`quantity-${productKey(product)}`);

      // Update state with the updated products
      setSelectedProducts(updatedProducts);
  };

  return (
    <MultiStepForm cartProps={{ onRemoveFromSelectedProducts: handleRemoveFromSelectedProducts, onAddSelectedProduct: handleSelect, selectedProducts: selectedProducts }} />
  );
};

export default HomePage;
